import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";
import { TrendingUp, TrendingDown } from "lucide-react";

interface RewardHistoryItem {
  reward_change: number;
  snapshot_time: string;
  id?: string;
}

interface RewardsHistoryProps {
  rewardsHistory: RewardHistoryItem[];
}

export function RewardsHistory({ rewardsHistory }: RewardsHistoryProps) {
  if (!rewardsHistory || !Array.isArray(rewardsHistory)) {
    return (
      <div className="text-center text-muted-foreground py-4">
        No rewards history available
      </div>
    );
  }

  const validRewards = rewardsHistory.filter(
    reward => reward && 
    typeof reward.reward_change === 'number' && 
    reward.snapshot_time
  );

  if (validRewards.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-4">
        No valid rewards data available
      </div>
    );
  }

  const getRewardIcon = (rewardChange: number) => {
    // If reward is above 90, it's likely a withdrawal
    if (rewardChange >= 90) {
      return <TrendingDown className="h-4 w-4 text-red-500" />;
    }
    // For regular rewards
    return <TrendingUp className="h-4 w-4 text-green-500" />;
  };

  return (
    <Card className="w-full md:w-1/2">
      <CardHeader>
        <CardTitle className="text-lg font-medium">Recent Rewards</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[400px] pr-4">
          {validRewards.map((reward, index) => {
            const uniqueKey = `${reward.snapshot_time}-${index}`;
            return (
              <div
                key={uniqueKey}
                className="flex items-center justify-between py-3 border-b last:border-0"
              >
                <div className="flex items-center space-x-3">
                  {getRewardIcon(reward.reward_change)}
                  <div className="flex flex-col">
                    <span className={`font-medium ${reward.reward_change >= 90 ? 'text-red-500' : 'text-green-500'}`}>
                      {reward.reward_change.toLocaleString()} DUSK
                    </span>
                    <span className="text-sm text-muted-foreground">
                      {format(new Date(reward.snapshot_time), 'MMM dd, HH:mm')}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </ScrollArea>
      </CardContent>
    </Card>
  );
}